import { render, staticRenderFns } from "./footer-info.vue?vue&type=template&id=2d8ef57f&scoped=true&"
import script from "./footer-info.ts?vue&type=script&lang=ts&"
export * from "./footer-info.ts?vue&type=script&lang=ts&"
import style0 from "./footer-info.scss?vue&type=style&index=0&id=2d8ef57f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8ef57f",
  null
  
)

export default component.exports